import React from 'react';
import { Phone, Clock } from 'lucide-react';
import { companyInfo } from '../data/mock';

const EmergencyBanner = () => {
  return (
    <div className="bg-red-600 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-center md:text-left">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 p-3 rounded-full">
              <Clock size={32} />
            </div>
            <div>
              <h3 className="text-2xl font-bold">24/7 Emergency Leak Service</h3>
              <p className="text-red-100">Available 7 days a week</p>
            </div>
          </div>
          <div className="hidden md:block w-px h-16 bg-white/30"></div>
          <a 
            href={`tel:${companyInfo.phone.replace(/\D/g, '')}`}
            className="flex items-center gap-3 bg-black hover:bg-gray-900 px-8 py-4 rounded-lg transition-colors shadow-lg"
          >
            <Phone size={24} />
            <div>
              <div className="text-sm text-gray-300">Call Now</div>
              <div className="text-2xl font-bold">{companyInfo.phone}</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default EmergencyBanner;
